import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { AccaBoostBaseModule } from '../../../lib/acca-boost-base/acca-boost-base.module';
import BetslipBaseModule from '../../base/betslip-base.module';
import { AccaBoostCarouselItemComponent } from './components/digital/acca-boost-carousel-item/acca-boost-carousel-item.component';
import { AccaBoostCarouselMaxBoostItemComponent } from './components/digital/acca-boost-carousel-max-boost-item/acca-boost-carousel-max-boost-item.component';
import { AccaBoostErrorComponent } from './components/digital/acca-boost-error/acca-boost-error.component';
import { AccaBoostGoToBetslipComponent } from './components/digital/acca-boost-go-to-betslip/acca-boost-go-to-betslip.component';
import { AccaBoostIconComponent } from './components/digital/acca-boost-icon/acca-boost-icon.component';
import { AccaBoostLadderCarouselUsComponent } from './components/digital/acca-boost-ladder-carousel-us/acca-boost-ladder-carousel-us.component';
import { AccaBoostLadderCarouselComponent } from './components/digital/acca-boost-ladder-carousel/acca-boost-ladder-carousel.component';
import { AccaBoostLadderUsInfoLegsListComponent } from './components/digital/acca-boost-ladder-us-info-legs-list/acca-boost-ladder-us-info-legs-list.component';
import { AccaBoostLadderUsInfoSportsComponent } from './components/digital/acca-boost-ladder-us-info-sports/acca-boost-ladder-us-info-sports.component';
import { AccaBoostLadderUsInfoComponent } from './components/digital/acca-boost-ladder-us-info/acca-boost-ladder-us-info.component';
import { AccaBoostLadderComponent } from './components/digital/acca-boost-ladder/acca-boost-ladder.component';
import { AccaBoostMaxRewardComponent } from './components/digital/acca-boost-max-reward/acca-boost-max-reward.component';
import { AccaBoostNotificationComponent } from './components/digital/acca-boost-notification/acca-boost-notification.component';
import { AccaBoostPayoutInfoComponent } from './components/digital/acca-boost-payout-info/acca-boost-payout-info.component';
import { AccaBoostTeaserComponent } from './components/digital/acca-boost-teaser/acca-boost-teaser.component';
import { AccaBoostUpdateInfoComponent } from './components/digital/acca-boost-update-info/acca-boost-update-info.component';
import { AccaBoostWinningsComponent } from './components/digital/acca-boost-winnings/acca-boost-winnings.component';
import { AccaBoostTrackingService } from './services/digital/acca-boost-tracking.service';
import { SharedAccaBoostModule } from './shared-acca-boost.module';

@NgModule({
    imports: [
        CommonModule,
        AccaBoostBaseModule,
        BetslipBaseModule,
        SharedAccaBoostModule,
        TrustPipe,
        StringInterpolationPipe,
        IconCustomComponent,
        AccaBoostIconComponent,
    ],
    declarations: [
        AccaBoostPayoutInfoComponent,
        AccaBoostWinningsComponent,
        AccaBoostGoToBetslipComponent,
        AccaBoostNotificationComponent,
        AccaBoostLadderComponent,
        AccaBoostTeaserComponent,
        AccaBoostMaxRewardComponent,
        AccaBoostUpdateInfoComponent,
        AccaBoostCarouselItemComponent,
        AccaBoostCarouselMaxBoostItemComponent,
        AccaBoostErrorComponent,
        AccaBoostLadderCarouselComponent,
        AccaBoostLadderCarouselUsComponent,
        AccaBoostLadderUsInfoComponent,
        AccaBoostLadderUsInfoSportsComponent,
        AccaBoostLadderUsInfoLegsListComponent,
    ],
    exports: [
        AccaBoostNotificationComponent,
        AccaBoostLadderComponent,
        AccaBoostTeaserComponent,
        AccaBoostMaxRewardComponent,
        AccaBoostPayoutInfoComponent,
        AccaBoostCarouselItemComponent,
        AccaBoostCarouselMaxBoostItemComponent,
        AccaBoostErrorComponent,
        AccaBoostLadderCarouselComponent,
        AccaBoostLadderCarouselUsComponent,
        AccaBoostLadderUsInfoComponent,
        AccaBoostLadderUsInfoSportsComponent,
        AccaBoostLadderUsInfoLegsListComponent,
    ],
    providers: [AccaBoostTrackingService],
})
export class DigitalAccaBoostModule {}
